module.exports = __webpack_public_path__ + "img/qrcode-douyin.f07ab98a.png";